import {useCurrentTheme} from "@/theming/useCurrentTheme";
import {getStatusBarStyle} from "@/lib/color";
import {StatusBar} from "expo-status-bar";

export function StatusBarMatcher() {
    const {theme} = useCurrentTheme();
    const statusBarStyle = getStatusBarStyle(theme.colors.background);

    return (
        <StatusBar style={statusBarStyle}/>
    );
}
